import React from 'react';
import { Navigate } from 'react-router-dom';

const Wishlist: React.FC = () => {
    return <Navigate to="/?wishlist=open" replace />;
};

export default Wishlist;
